import { useMutation, useQuery, UseQueryOptions } from "@tanstack/react-query";
import {
  findCivilites,
  findSyndicatsAffilies,
} from "../services/referentiels.service";
import { CivilitesResult } from "../interfaces/referentiels.interface";
import { ksCivilitesQK } from "../query-keys";

type QueryOptions<T> = Omit<UseQueryOptions<T>, "queryKey" | "queryFn">;

export const useCivilites = (options?: QueryOptions<CivilitesResult>) =>
  useQuery({
    queryKey: [ksCivilitesQK],
    queryFn: findCivilites,
    ...options,
  });

export const useFindSyndicatsAffilies = () =>
  useMutation({
    mutationFn: findSyndicatsAffilies,
  });
